/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a.user-label[_ngcontent-%COMP%]{white-space:nowrap;overflow:visible}.label[_ngcontent-%COMP%]{padding:0;margin:0!important}.label[_ngcontent-%COMP%]   .username[_ngcontent-%COMP%]{margin-right:4px}.label[_ngcontent-%COMP%]:hover   .username[_ngcontent-%COMP%]{color:#8fc5f5}"];
export { styles as styles };
